var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleFoldedContent1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2092 1.01123V7.0337H22.2877L16.2092 1.01123Z",
    fill: "#00A851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2092 1.01123V7.0337H22.2877",
    stroke: "#00A851",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2091 1.01123H2.02612V23.0936H22.2876V7.0337L16.2091 1.01123Z",
    stroke: "#00A851",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09155 7.03369H11.1438",
    stroke: "#00A851",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09155 12.0522H17.2223",
    stroke: "#00A851",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09155 17.0713H17.2223",
    stroke: "#00A851",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3137,
    height: 24.0899,
    fill: "white",
    transform: "translate(0 0.00732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleFoldedContent1);
export default __webpack_public_path__ + "static/media/single-folded-content1.bc9a7aea2d0a43373b33e2d3342e7a3d.svg";
export { ForwardRef as ReactComponent };